<app-breadcrumb></app-breadcrumb>
<div class="col-sm-12" >
  <div class="card">
    <div class="card-header">
      <h5>{{title}}</h5>
    </div>
    <div class="card-body" >
      <form class="theme-form" [formGroup]="form" >
        <div class="form-group row">
          <label class="col-sm-3 col-form-label" for="inputEmail3">Full Name</label>
          <div class="col-sm-9">
            <input class="form-control" id="" type="text" placeholder="Full Name" formControlName="name"
              [ngClass]="{ 'is-invalid': (isFormSubmitted && form.controls.name.errors) || (!form.controls.name.pristine && form.controls.name.invalid) }" 
              [(ngModel)]="row[0].name"
              />
            <div class="invalid-feedback"
              *ngIf="(isFormSubmitted && form.controls.name.errors) || (!form.controls.name.pristine && form.controls.name.invalid)">
              <div *ngIf="form.controls.name.errors.required">
                <h5 style="color:red">Name is required</h5>
              </div>
              <div *ngIf="form.controls.name.errors.pattern">
                <h5 style="color:red">Only Alphabets with space
                  between 2 to
                  20
                  characters</h5>
              </div>

            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label" for="inputEmail3">Email</label>
          <div class="col-sm-9">
            <input class="form-control" id="inputEmail3" type="email" placeholder="Email" formControlName="email"
              [ngClass]="{ 'is-invalid': (isFormSubmitted && form.controls.email.errors) || (!form.controls.email.pristine && form.controls.email.invalid) }"
              [(ngModel)]="row[0].email"
              >
            <div class="invalid-feedback"
              *ngIf="(isFormSubmitted && form.controls.email.errors) || (!form.controls.email.pristine && form.controls.email.invalid)">
              <div *ngIf="form.controls.email.errors.required">
                <h5 style="color:red">Email is required</h5>
              </div>
              <div *ngIf="form.controls.email.errors.pattern">
                <h5 style="color:red">Enter valid emai</h5>
              </div>

            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3 col-form-label" for="inputPassword3">Address</label>
          <div class="col-sm-9">
            <input class="form-control" id="url" type="text" placeholder="Address" formControlName="address"
              [ngClass]="{ 'is-invalid': (isFormSubmitted && form.controls.address.errors) || (!form.controls.address.pristine && form.controls.address.invalid) }"
              [(ngModel)]="row[0].address"
              >
            <div class="invalid-feedback"
              *ngIf="(isFormSubmitted && form.controls.address.errors) || (!form.controls.address.pristine && form.controls.address.invalid)">
              <div *ngIf="form.controls.address.errors.required">
                <h5 style="color:red">Address is required</h5>
              </div>

            </div>
          </div>
        </div>
        <div class="form-group row" *ngIf="hide">
          <label class="col-sm-3 col-form-label">Client</label>
          <div class="col-sm-9" >
                  
                  <select class="form-control digits" id="exampleFormControlSelect9"  formControlName="client_id" >
                      <option *ngFor="let client of data" value="{{client.id}}" [(ngModel)]="row[0].client_name">{{client.name}}</option>
                      
                  </select>
             
          </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Status</label>
        <div class="col-sm-9">

          <select class="form-control digits" id="exampleFormControlSelect9" [(ngModel)]="row[0].status"formControlName="status">
            <option value="1" >Active</option>
            <option value="0">Inactive</option>
          </select>

        </div>
      </div>
      </form>
    </div>
    <div class="card-footer" style=" padding-left:50px;">
      <button class="btn btn-primary" type="button" [disabled]="!form.valid" style="width: 100px; height: 30px;" (click)=onSubmit() placement="top"
      ngbTooltip="submit" >Submit</button>&nbsp;
      <button class="btn btn-warning" type="button" placement="top" style=" width: 100px; height: 30px;"
        ngbTooltip="reset" (click)="onCancel()">Reset</button>
    </div>
  </div>
</div>